import { TitleCasePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";

import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { ComponentBase } from "app/shared/component.base";
import { ScanQrCodeComponent } from "app/shared/components/scan-qr-code/scan-qr-code.component";
import { SingleDetailComponent } from "app/shared/components/single-detail/single-detail.component";
import {
  LabelCode,
  LabelCodeType,
  LabelCodeTypeMap,
} from "app/shared/models/label-code.models";
import { FormControlPipe } from "app/shared/pipes/form-control.pipe";
import { FilterStateService } from "app/shared/services/filter-state.service";
import { GlobalFilterService } from "app/shared/services/global-filter-state.service";

import { ScannedAccountDetailsComponent } from "./scanned-account-details/scanned-account-details.component";
import { ScannedBottleDetailsComponent } from "./scanned-bottle-details/scanned-bottle-details.component";
import { ScannedCaseDetailsComponent } from "./scanned-case-details/scanned-case-details.component";
import { ScannedInboundReceiptDetailsComponent } from "./scanned-inbound-receipt-details/scanned-inbound-receipt-details.component";
import { ScannedLocationDetailsComponent } from "./scanned-location-details/scanned-location-details.component";
import { ScannedTransitUnitDetailsComponent } from "./scanned-transit-unit-details/scanned-transit-unit-details.component";

@Component({
  selector: "app-global-qr-navigator-dialog",
  templateUrl: "./global-qr-navigator-dialog.component.html",
  styleUrls: ["./global-qr-navigator-dialog.component.scss"],
  providers: [
    FilterStateService,
    GlobalFilterService,
    { provide: Window, useValue: window },
  ],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    SingleDetailComponent,
    ScanQrCodeComponent,
    ScannedAccountDetailsComponent,
    ScannedBottleDetailsComponent,
    ScannedCaseDetailsComponent,
    ScannedInboundReceiptDetailsComponent,
    ScannedLocationDetailsComponent,
    ScannedTransitUnitDetailsComponent,
    FormControlPipe,
    TitleCasePipe,
  ],
})
export class GlobalQrNavigatorDialogComponent
  extends ComponentBase
  implements OnInit
{
  public scannedCodeFormGroup: UntypedFormGroup;
  public labelCode: LabelCode;
  public labelCodeType: LabelCodeType;
  public candidateNavigationInstructions: [string, number] = null;
  public scanFailure: boolean;
  public labelCodeTypeMap: any = LabelCodeTypeMap;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<GlobalQrNavigatorDialogComponent>,
    private router: Router,
    private window: Window
  ) {
    super();
  }

  ngOnInit(): void {
    this.scannedCodeFormGroup = this.formBuilder.group({
      scannedQrCode: [null, Validators.required],
    });

    this.scannedCodeFormGroup
      .get("scannedQrCode")
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((labelCode: LabelCode) => {
        if (!labelCode?.type || labelCode.type === "Unknown") {
          this.handleScanFailure();
          return;
        }
        this.labelCode = labelCode;
        this.scanFailure = false;
      });
  }

  updateCandidateNavigation(navigationInstructions: [string, number]) {
    this.candidateNavigationInstructions = navigationInstructions;
  }

  navigateToScannedItem(openInNewTab: boolean = false) {
    if (openInNewTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(this.candidateNavigationInstructions)
      );

      this.window.open(url, "_blank");
    } else {
      this.dialogRef.close();
      this.router.navigate(this.candidateNavigationInstructions);
    }
  }

  handleScanFailure() {
    this.candidateNavigationInstructions = null;
    this.scanFailure = true;
  }
}
